var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"banner"},[_c('div',{staticClass:"swiper-wrapper"},_vm._l((_vm.banner.item),function(val){return _c('div',{staticClass:"swiper-slide"},[_c('img',{staticClass:"bannerPic",attrs:{"src":val.img}})])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }